<!-- <div *ngIf="showXButton" class="col-md-12" style="margin-top: -25px; margin-left: 20px; text-align: right">
    <a (click)="cancelButton()" style="cursor: pointer;">
        <br>
        <mat-icon class="nc-icon-glyph ui-1_simple-remove" style="margin: auto; transform: scale(1.5);"></mat-icon>
    </a> -->
<!-- <button type="button" class="btn btn-md btn-primary" style="margin: auto;">Export To Excel</button> -->
<!-- </div> -->

<div class="col-md-12 stickyTitle"
    style="top:-25px; margin-top: -25px; text-align: right; background-color: white; opacity: 1;">
    <!-- <a *ngIf="showXButton" (click)="cancelButton()" style="cursor: pointer;">
        <br>
        <mat-icon class="nc-icon-glyph ui-1_simple-remove"
            style="padding-top: 10px; margin: auto; transform: scale(1.5);"></mat-icon>
    </a> -->
    <!-- <button type="button" class="btn btn-md btn-primary" style="margin: auto;">Export To Excel</button> -->
    <div class="PageTitle">
        <h3 style="text-align: center;" class="reduce-margin"><b>{{ moduleTitle }} List Corps</b></h3>
    </div>
</div>

<!-- <h3 style="text-align:center" mat-dialog-title><b>{{ moduleTitle }} List Corps</b></h3>
<hr> -->
<div [hidden]="!hidePage" class="container white_bg" style="padding-top: 40px;">
    <h2 style="padding-left: 35%;" [hidden]="!loadingCorpsBanner">Please Wait, Loading Available Corps</h2>
    <h2 style="padding-left: 35%;" [hidden]="!savingCorpsBanner">Please Wait, Saving Corps</h2>
    <div id="preloader-wrapper">
        <div id="preloader" class="preloader2"> </div>
    </div>
</div>

<div class="row special-reduce-margin" style="margin-bottom: 0px; padding-bottom:100%;" [hidden]="hidePage">

    <!-- <div class="row"> -->

<br>
<br>
<br>
<br>
    <div class="row" style="position:absolute">

        <div class="col-md-1 reduce-margin" style="position:absolute">
            <div class="row" style="width: 100px;">
                <h4><b>Template:</b></h4>
            </div>

            <div class="reduce-margin" style="width: auto;">
                <h4 style="font-size:16px; white-space: nowrap">{{ templateDesc }}</h4>
            </div>
        </div>

        <div class="col-md-11" [hidden]="viewOnlyMode">

            <div class="col-md-offset-1" style="position:absolute;">
                <div class="row" style="padding-left: 300px;">
                    <div class="col-md-1 reduce-margin" style="width: 50px;">
                        <h4><b>Client</b></h4>
                    </div>
                </div>

                <div class="col-md-1 reduce-margin" style="width:300px; position:absolute; padding-left: 315px;">
                    <reusable-typeahead-search #search0 (messageEventObject)="receiveMessageObj($event)"
                        (messageEvent)="searchReceiveMessage($event)" [events]="clientEventSubject.asObservable()">
                    </reusable-typeahead-search>
                </div>

                <div class="col-md-1 reduce-margin" style="width:125px; position:absolute; margin-left: 515px;">
                    <reusable-corp-search #fromCorp (messageEvent)="fromReceiveMessage($event)"
                        [events]="fromEventSubject.asObservable()"></reusable-corp-search>
                </div>

                <div class="col-md-1 reduce-margin" style="width:125px; position:absolute; margin-left: 615px;">
                    <reusable-corp-search #toCorp (messageEvent)="toReceiveMessage($event)"
                        [events]="toEventSubject.asObservable()"></reusable-corp-search>
                </div>

                <div class="col-md-1" style="width:250px">
                    <div class="row">
                        <div class="col-md-1 reduce-margin" style="margin-top: -40px; position:absolute; margin-left: 715px;">
                            <h4 style="color: red" class="no-wrapping prehold-font-size"><b
                                    style="color:black">Facility</b>
                            </h4>
                        </div>
                    </div>
                    <!-- <div class="row"> -->
                    <div class="reduce-margin col-md-1" style="position:absolute; margin-left: 715px;">
                        <mat-form-field style="width: 200px" appearance="outline" class="standard-font-sizing">
                            <mat-select [formControl]="facilityControl">
                                <mat-option (click)="selectAll()" [value]="allSelectedValue">
                                    All Facilities
                                </mat-option>

                                <ng-container *ngIf="!toggleAllSelected; else allSelected">
                                    <mat-option *ngFor="let facility of filteredFacilities" [value]="facility"
                                        (click)="facilityIdLookup(facility.facilityNm, 'true')">
                                        {{ facility.facilityNm }}
                                    </mat-option>
                                </ng-container>
                                <ng-template #allSelected>
                                    <!--No List of facilities appear-->
                                </ng-template>

                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!-- </div> -->
                </div>

                <div class="col-md-1" id="buttonRow" style="position:absolute; margin-left: 935px;">
                    <div style="margin-top: -7px;">
                        <button (click)="clientSearchButton()" type="button" class="btn btn-md btn-primary" [disabled]="searchButtonDisable"
                            style="margin: auto;">Search</button>
                    </div>
                </div>

            </div>

        </div>


    </div>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <div class="row" id="buttonRow" [hidden]="hidePage">
        <div [hidden]="viewOnlyMode" class="col-md-1 reduce-margin">
            <button [disabled]="toggleSaveButton" (click)="saveButton()" type="button" class="btn btn-md btn-primary"
                style="margin: auto;">Save</button>
        </div>

        <div class="col-md-1 reduce-margin">
            <button (click)="cancelButton()" type="button" class="btn btn-md btn-primary"
                style="margin: auto;">Cancel</button>
        </div>
    </div>
    <br>
    <br>
    <br>
    <br>


    <!-- left side -->
    <div class="reduce-margin" style="border-right: 0px solid lightsteelblue; height: auto;">

        <div class="col-md-5 reduce-margin">


            <div class="row">
                <div class="col-md-1" style="width: auto; position:absolute;">
                    <h4 style="display: inline-block; white-space: nowrap;"><b>Associated Corps</b></h4>
                </div>

                <!-- Row 2 -->
                <div class="col-md-1" style="white-space: nowrap; width: auto; position:absolute; margin-left: 150px;">
                    <h4><b>&nbsp;&nbsp;&nbsp;&nbsp;Filter Corp:</b></h4>
                </div>

                <div class="col-md-1" style="width: 150px; position:absolute; margin-left: 270px;">
                    <mat-form-field class="reduce-margin no-wrapping" style="width: 100px">
                        <input type="text" matInput [formControl]="assocFilterControl">
                        <!-- <mat-error *ngIf="workUnitSizeControl.status === 'INVALID'">Value must be positive</mat-error> -->
                    </mat-form-field>
                </div>

                <div class="col-md-1" style="position:absolute; margin-left: 390px;">
                    <button [disabled]="disableExport" id="exportButton" aria-hidden="true" (click)="downloadCsv()" matTooltip="Export to CSV"
                        class="btn btn-md btn-primary">Export</button>
                </div>
            </div>

            <div class="row">
                <!-- <div class="col-md-1" style="width: 550px; margin-left: -50px; overflow: scroll;"> -->
                <!-- source corp table  -->
                <div style="max-width: auto; position:absolute; margin-top: 75px;">
                    <reusable-table-app #table0 (messageEvent)="table0ReceiveMessage($event)"
                        [events]="tableEventSubject.asObservable()" [displayedColumns]="displayedColumns"
                        [columns]="columns" [pageSizeOptions]="pageSizeOptions"
                        [checkboxHeader]="checkboxHeader"></reusable-table-app>
                </div>
            </div>


        </div>

        <div class="col-md-1" style="margin-left: -75px;  margin-right: 0px; padding-top: 70px;">
            <div class="row" style="position:absolute; margin-left:665px; margin-top: 50px;">
                <div class="col-md-1" style="width: 50px;">
                    <!-- <br><br><br><br> -->
                    <a [hidden]="viewOnlyMode" style="cursor: pointer;" (click)="dissacCorps()">
                        <mat-icon class="nc-icon-glyph arrows-1_circle-right-09" style="transform: scale(3);">
                        </mat-icon>
                    </a>
                </div>

                <div class="col-md-1" style="display: inline-block; white-space: nowrap; position:absolute;">
                    <a [hidden]="viewOnlyMode" style="cursor: pointer;" (click)="assocCorps()">
                        <mat-icon class="nc-icon-glyph arrows-1_circle-left-10" style="transform: scale(3);">
                        </mat-icon>
                    </a>
                </div>
            </div>
        </div>

        <div [hidden]="viewOnlyMode" class="col-md-6 reduce-margin" style="margin-left: -50px; margin-right: 0px;">
            <div class="row">
                <div class="col-md-1" style="position:absolute; margin-left: 750px;">
                    <h4
                        style="margin-left:-15px; padding-left:0px; padding-top:0px; display: inline-block; white-space: nowrap;">
                        <b>Available Corps</b></h4>
                </div>
            </div>
            <div class="row" style="position:absolute; margin-left: 750px; margin-top: 75px;">
                <!-- target table -->
                <!-- <div class="col-md-11" style="width: 530px; overflow: auto; max-height: 600px; display: inline-block; white-space: nowrap"> -->
                <reusable-table-app #table1 (messageEvent)="table1ReceiveMessage($event)"
                    [events]="table1EventSubject.asObservable()" [displayedColumns]="displayedColumns1"
                    [columns]="columns1" [pageSizeOptions]="pageSizeOptions"
                    [checkboxHeader]="checkboxHeader"></reusable-table-app>
                <!-- </div> -->
            </div>
        </div>

        <br><br><br><br>



        <!-- <div class="col-md-1" style="width: 1%"></div> -->


    </div>

</div>

<div class="row" style="background-color: white; overflow: hidden;">

    
</div>

<!-- Announcement Ticket -->
<!-- <div *ngIf="saveOccured">
    <ng-container *ngIf="saveStatus; else ticketTemplate">
        <h3 style="text-align:center"><b style="color:#00A3D6">Save Complete!</b></h3>
    </ng-container>
    <ng-template #ticketTemplate>
        <h3 style="text-align:center"><b style="color:lightcoral">Save did not go through.</b></h3>
    </ng-template>
</div> -->